import { fetchStatistics as fetchStatisticsFromApi } from '@/api/proxy'
import { objectHasKeys } from '@/utils/comparators'
import { fiveMinutesPolicyHasExpired } from '@/utils/cachePolicies'

/**
* Fetch user statistics from API
*/
const fetchStatistics = async ({ commit }) => {
  let response = await fetchStatisticsFromApi()
  commit('SET_STATISTICS', response)
}

/**
* Load user statistics.
* If cache is empty or stale fetch it from API
*/
const loadStatistics = async ({ dispatch, state }) => {
  if (fiveMinutesPolicyHasExpired(state.statisticsCreated) || !objectHasKeys(state.statistics)) {
    await dispatch('fetchStatistics')
  }
}

export default {
  fetchStatistics,
  loadStatistics
}



// WEBPACK FOOTER //
// ./src/store/modules/user/statistics/actions.js